<template>
  <AddDiscount />
</template>
<script>
import appConfig from '@/app.config'
import AddDiscount from '../../../components/dadban/discount/AddDiscount.vue'
export default {
  page: {
    title: 'اضافه کردن کد تخفیف',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-discount',
  components: {
    AddDiscount,
  },
}
</script>
